import { useContext as c } from "react";
import { ScaleContext as a } from "../components/Scale/ScaleContext.js";
import { DEFAULT_SCALE_FACTOR as m } from "../config/globalConstants.js";
import { MEDIA_QUERY_LARGE as s } from "../config/breakpoints.js";
import { useMatchMedia as i } from "./useMatchMedia.js";
const F = (e, o = m) => {
  const { scaleFactor: r } = c(a), t = e ?? r;
  return i(s) ? t : o;
};
export {
  F as useScaleFactor
};
